import * as React from "react";
import { withLocalization, LocalizedComponentClass } from "bernie-l10n";
import { TrackedLink } from "components/utility/analytics/TrackedLink";
import { useLocalization } from "@shared-ui/localization-context";

interface ReviewCardLinkProps {
  hotelName: string;
  index: number;
  hotelInfositeUrl: string;
}

const ReviewCardLink = (props: ReviewCardLinkProps) => {
  const { formatText } = useLocalization();

  return (
    <TrackedLink
      title={formatText("hotelRecentReviews.linkTitle", props.hotelName)}
      className="uitk-card-link"
      moduleName="hotel-recent-reviews"
      rfrr={`card-${props.index}`}
      href={`${props.hotelInfositeUrl}#review-summary`}
    >
      {props.hotelName}
    </TrackedLink>
  );
};

export const LocalizedReviewCardLink: LocalizedComponentClass<ReviewCardLinkProps> = withLocalization(ReviewCardLink);
